<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 9741 9741"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="4871" cy="4871" r="4871"/>
     <g id="_879656808">
     <g>
      <path class="fil1" d="M6628 3506c0,339 463,271 463,0 0,-296 -463,-300 -463,0z"/>
       <path class="fil1" d="M5403 4431c0,261 462,305 462,-23 0,-291 -462,-303 -462,23z"/>
       <path class="fil1" d="M6212 5981c277,0 277,-463 0,-463 -327,0 -324,463 0,463z"/>
       <path class="fil1" d="M6628 6189c0,318 463,282 463,0 0,-284 -463,-321 -463,0z"/>
       <path class="fil1" d="M5403 5356c0,243 462,306 462,-23 0,-288 -462,-319 -462,23z"/>
       <path class="fil1" d="M4871 4871c0,328 462,265 462,23 0,-343 -462,-312 -462,-23z"/>
       <path class="fil1" d="M6628 5310c0,74 15,137 53,179 137,151 410,50 410,-156 0,-309 -463,-274 -463,-23z"/>
       <path class="fil1" d="M6166 5102c378,0 292,-463 46,-463 -135,0 -228,91 -246,217 -15,109 94,246 200,246z"/>
       <path class="fil1" d="M6628 4408c0,345 463,268 463,0 0,-272 -463,-309 -463,0z"/>
       <path class="fil1" d="M6189 4200c147,0 231,-84 231,-231 0,-203 -254,-290 -387,-157 -142,142 -40,388 156,388z"/>
     </g>
       <rect class="fil1" x="3629" y="3109" width="769" height="3479" rx="384" ry="156"/>
       <rect class="fil1" x="2729" y="2055" width="769" height="5586" rx="384" ry="408"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'SwimmingPoolJet',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
